import React from "react"
import {
  BaseEdge,
  EdgeProps,
  getSmoothStepPath
} from "@xyflow/react"

/**
 * Read-only edge for the execution view. The Then / Otherwise branch
 * indicator is rendered once on the ConditionNode itself, so the edge
 * stays unadorned.
 */
const ExecutionEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  style
}: EdgeProps) => {
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 8
  })

  return <BaseEdge id={id} path={edgePath} markerEnd={markerEnd} style={style} />
}

export default ExecutionEdge
